import React from 'react';
import classes from './Layout.module.css';
import Toolbar from '../../../components/Navigation/Toolbar/Toolbar';
import Footer from '../../../components/Navigation/Footer/Footer';

const Layout = (props) => {

	return (
		<div className={classes.Layout}>
			<Toolbar />
			<main className={classes.Content}>{props.children}</main>
			<Footer />
		</div>
	);
};

export default Layout;
